<template>
  <div class="fit flex flex-col overflow-hidden">
    <q-tabs v-model="tab" class="text-teal" dense align="center">
      <q-tab name="tyre" label="Tyre" />
      <q-tab name="documents" label="Documents" />
      <q-tab name="engine" label="Engine" />
      <q-tab name="history" label="History Logs" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated class="flex-1 overflow-hidden">
      <q-tab-panel name="tyre" class="fit p-0">
        <TyreMaintenace />
      </q-tab-panel>
      <q-tab-panel name="documents" class="flex">
        <MaintenanceTable class="w-full" data="documents" />
      </q-tab-panel>
      <q-tab-panel name="engine" class="flex">
        <MaintenanceTable class="w-full" data="engine" />
      </q-tab-panel>
      <q-tab-panel name="history" class="flex">
        <MaintenanceTable class="w-full" data="history" />
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import MaintenanceTable from './components/MaintenanceTable.vue';
import TyreMaintenace from './tire/TyreMaintenance.vue';

const tab = ref('tyre');
</script>

<style scoped></style>
